export function existSensor(obj_ns, sensor) {
    switch (obj_ns) {
        case 'radiosensors':
        case 'analog_temperature_sensors':
        case 'wired_temperature_sensors':
            return sensor;
        default:
            return null;
    }
}
